import React from 'react'
import Image from 'next/image'

//!MOCKDATA
import bannerImage from '@/assets/img/news/banner.png'
import { NewsItem } from '@/redux/services/newsApi'
import NewsCard from './NewsCard'
import Link from 'next/link'
import Calendar from '../Calendar/Calendar'

interface Props {
    buttonMore: Boolean
    data: NewsItem[]
    count: number
    setCount: React.Dispatch<React.SetStateAction<number>>
    totalCount: number
}

const NewsCardList: React.FC<Props> = ({ buttonMore, data, count, setCount, totalCount }) => {
    return (
        <>
            <div className='container'>
                <ul className='news__card-list'>
                    {data &&
                        data.slice(0, 6)?.map((card, i) => {
                            // if(card.enableToView == true){
                            return (
                                <NewsCard
                                    card={card}
                                    key={i}
                                />
                            )
                            // }
                        })}
                </ul>
            </div>
            <div className='container'>
                <Calendar />
            </div>
            {data.length > 6 ? (
                <div className='container'>
                    <ul
                        style={buttonMore ? { marginBottom: 120 } : {}}
                        className='news__card-list'
                    >
                        {data &&
                            data.slice(6)?.map((card, i) => (
                                <NewsCard
                                    card={card}
                                    key={i}
                                />
                            ))}
                    </ul>
                </div>
            ) : null}
            {buttonMore && count < totalCount && (
                <button
                    onClick={() => setCount(count + 10)}
                    className='news__button-more button-more'
                >
                    Загрузить еще
                </button>
            )}
        </>
    )
}

export default NewsCardList
